import {Component} from '@angular/core';
import {MdDialog} from '@angular/material';
/**
 * \@title Dialog elements
 */
export class DialogElementsExample {
/**
 * @param {?} dialog
 */
constructor(public dialog: MdDialog) { }
/**
 * @return {?}
 */
openDialog() {
    this.dialog.open(DialogElementsExampleDialog);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-elements-example',
  templateUrl: 'dialog-elements-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdDialog, },
];
}

function DialogElementsExample_tsickle_Closure_declarations() {
/** @type {?} */
DialogElementsExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogElementsExample.ctorParameters;
/** @type {?} */
DialogElementsExample.prototype.dialog;
}

export class DialogElementsExampleDialog { static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'dialog-elements-example-dialog',
  templateUrl: 'dialog-elements-example-dialog.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DialogElementsExampleDialog_tsickle_Closure_declarations() {
/** @type {?} */
DialogElementsExampleDialog.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DialogElementsExampleDialog.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
